import { SubscriptionLike } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Location } from '@angular/common';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { TicketRequest } from 'src/app/shared/model/ticket-access-request.model';
import { MESSAGE_TOAST } from 'src/app/shared/enums/message-toast-enum';
import { ConfirmationDialogComponent } from 'src/app/shared/components/dialog/confirmation-dialog.component';
import { Spinner } from 'src/app/core/services/spinner.service';
import { IntelexSupplierAudit } from 'src/app/shared/model/intelexSupplierAudit.model';
import { IntelexSupplierAuditService } from 'src/app/shared/service/intelex-supplier-audit.service';
import { IntelexSupplierAuditSSOComponent } from './search-sso/search-sso.component';

@Component({
  selector: 'app-intelex-supplier-audit-form',
  templateUrl: './intelex-supplier-audit-form.component.html',
  styleUrls: ['./intelex-supplier-audit-form.component.scss'],
  // tslint:disable-next-line:use-host-property-decorator
  host: {
    '(window:resize)': 'onWindowResize($event)'
  }
})
export class IntelexSupplierAuditFormComponent implements OnInit, OnDestroy {
  intelexSupplierAudit: IntelexSupplierAudit = new IntelexSupplierAudit();
  intelexSupplierAuditForm: FormGroup;
  request: TicketRequest[] = [];
  isSpin: boolean;
  checkSubmit: boolean;
  subscription: SubscriptionLike;
  width: number = window.innerWidth;
  types = ['Add New Supplier', 'Edit/Update Supplier'];
  businesses = [
    {id: 1,name: 'Onshore Wind'},
    {id: 2,name: 'Offshore Wind'},
    {id: 3,name: 'Grid Solutions'},
    {id: 4,name: 'LM'},
    {id: 5,name: 'Hydro'}
  ];
  SQEsso = '';

  ssoDialogRef: MatDialogRef<IntelexSupplierAuditSSOComponent>;

  constructor(
    private spinner: Spinner,
    private location: Location,
    private fb: FormBuilder,
    private toastService: ToastrService,
    private dialog: MatDialog,
    private service: IntelexSupplierAuditService
  ) { }

  ngOnInit(): void {
    this.initFormIntelexSupplierAudit();
    this.getListTicket();
  }

  getListTicket(event?) {
    if (event) {
      event.srcElement.classList.remove('rotate');
      setTimeout(() => {
        event.srcElement.classList.add('rotate');
      }, 0);
    }
    this.subscription = this.service.getRequestIntelexSupplierAuditAccessList().subscribe((res) => {
      this.request = res.data;
    }, (err) => {});
  }

  ngOnDestroy() {
    // unsubscribe
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  initFormIntelexSupplierAudit() {
    return this.intelexSupplierAuditForm = this.fb.group({
      id: [this.intelexSupplierAudit.id],
      reqType: [this.intelexSupplierAudit.reqType, [Validators.required]],
      supCompany: [this.intelexSupplierAudit.supCompany, [Validators.required]],
      supContactName: [this.intelexSupplierAudit.supContactName, [Validators.required]],
      supContactSso: [this.intelexSupplierAudit.supContactSso, [Validators.required]],
      supEmail: [this.intelexSupplierAudit.supEmail, [Validators.required]],
      business: [this.intelexSupplierAudit.business, [Validators.required]],
      gslNumber: [this.intelexSupplierAudit.gslNumber, [Validators.required]],
      siteCode: [this.intelexSupplierAudit.siteCode, [Validators.required]],
      sqeName: [this.intelexSupplierAudit.sqeName, [Validators.required]],
      jobTitle: [this.intelexSupplierAudit.jobTitle],
      phone: [this.intelexSupplierAudit.phone],
      extension: [this.intelexSupplierAudit.extension],
      detail: [this.intelexSupplierAudit.detail]
    });
  }

  /**
   * Marks all controls in a form group as touched
   * @param formGroup - The form group to touch
   */
  private markFormGroupTouched(formGroup: FormGroup): void {
    (Object as any).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  submitIntelexSupplierAuditForm(): void {
    if (this.checkSubmit) {
      this.setErrorForm(this.intelexSupplierAuditForm);
    }
    if (!this.intelexSupplierAuditForm.valid) {
      this.markFormGroupTouched(this.intelexSupplierAuditForm);
      return;
    } else {
      this.openDialog();
    }
  }

  goToApplication() {
    window.open('https://clients.intelex.com/Login3/GERenewableEnergy');
  }

  getInitFormByID(id) {
    this.spinner.show();
    this.service.getRequestIntelexSupplierAuditAccess(id).subscribe((res) => {
      this.spinner.hide();
      this.intelexSupplierAudit = new IntelexSupplierAudit(res.data);
      this.initFormIntelexSupplierAudit();
    });
  }

  openDialog() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: MESSAGE_TOAST.CONFIRM_REQUEST_ACCESS,
        buttonText: {
          ok: 'Yes',
          cancel: 'No'
        }
      }
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        
        const body = new IntelexSupplierAudit(this.intelexSupplierAuditForm.getRawValue(), false, this.SQEsso).convertToReqBody();
        this.spinner.show();
        this.service.requestIntelexSupplierAuditAccess(body).subscribe((res) => {
          this.service.createSupportCentralForm(res.data).subscribe();
          this.spinner.hide();
          this.toastService.success(MESSAGE_TOAST.REQUEST_ACCESS_TICKET_SUCCESS);
          setTimeout(() => {
            location.reload();
          }, 3000);
        });
      }
    });
  }

  setErrorForm(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((name) => {
      if (!formGroup.controls[name].value) {
        formGroup.controls[name].setErrors({ required: true });
      }
    });
    return formGroup;
  }

  selectBusiness($event) {
    // this.intelexSupplierAuditForm.controls.intelexSupplierAuditModule.reset();
    // this.intelexSupplierAuditForm.controls.gslNumber.reset();
    // this.intelexSupplierAuditForm.controls.siteCode.setErrors(null);
    // this.intelexSupplierAuditForm.controls.sqeName.setErrors(null);
  }

  searchSSO(event) {
    this.ssoDialogRef = this.dialog.open(IntelexSupplierAuditSSOComponent, {
      width: this.width > 1000 ? '40%' : '100%',
      maxWidth: '100%',
      maxHeight: '500px',
      data: {}
    });
    this.ssoDialogRef.afterClosed().pipe(
    ).subscribe(result => {
      this.intelexSupplierAuditForm.controls.sqeName.setValue(result.name);
      this.SQEsso = result.sso;
    });
  }

}
